/**
 * 配列(または連想配列)の要素数を数える
 */
module.exports = function(ary){
    return this.array_keys(ary).length;
}
